const RedirectUrl = {
  admin: "https://admin.ism.ly/login",
  teacher: "https://teacher.ism.ly/login",
  student: "https://student.ism.ly/login",
  parents: "https://parent.ism.ly/login",
  campusAdmin: "https://campus-admin.ism.ly/login",
};

export default RedirectUrl;
